import React from 'react';
import { Star } from 'lucide-react';
import { Section, SectionHeading } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <figure className="glass-panel gold-frame p-6 md:p-8 rounded-sm flex flex-col h-full" data-id="element-233" data-mp="3azt57ofmmxjh">
    <div className="flex items-center mb-5" data-id="element-234" data-mp="3700pmrrtfr4m">
      <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-goldDark font-display font-bold text-base md:text-lg border border-brand-gold/40 mr-4 shrink-0" data-id="element-235" data-mp="36wmotnysvpza">
        {initials}
      </div>
      <figcaption data-id="element-236" data-mp="2s2rtlkrkhz6k">
        <div className="flex text-brand-gold mb-1" aria-label="5 stelle su 5" data-id="element-237" data-mp="2s39syq9j0tip">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-238" data-mp="v8nar7dvcfh1" data-mpi={i} />)}
        </div>
        <div className="font-medium text-brand-purpleDark" data-id="element-239" data-mp="qbn3wu9738ov">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-240" data-mp="h5os1hpjsial">
          {location} {product && `— ${product}`}
        </div>
      </figcaption>
    </div>
    <blockquote className="text-brand-text/90 italic flex-grow text-sm md:text-base font-display text-[17px] leading-relaxed" data-id="element-241" data-mp="m6cgbvme6l14">
      “{text}”
    </blockquote>
  </figure>;
export const InitialTestimonials = () => <Section className="pb-16" data-id="element-242" data-mp="c8y1g0g4a4ax">
    <div className="max-w-3xl mx-auto" data-id="element-243" data-mp="zwpq83iug9t3">
      <TestimonialCard initials="CM" name="Chiara M." location="Bologna" text="Finalmente ho una base ordinata da cui partire. Preparo la lezione in metà tempo e durante l’incontro riesco davvero a osservare il gruppo invece di pensare al prossimo esercizio." data-id="element-244" data-mp="zxqzq3k7oo8p" />
    </div>
  </Section>;
const testimonials: TestimonialProps[] = [{
  initials: 'CM',
  name: 'Chiara M.',
  location: 'Bologna',
  product: 'Istruttrice di Qi Gong',
  text: 'Avevo tante idee sparse e nessun criterio per collegarle. Le lezioni pronte del Volume II mi hanno dato lo schema che mi mancava, e da lì costruisco le mie varianti.'
}, {
  initials: 'LR',
  name: 'Luca R.',
  location: 'Torino',
  product: 'Insegnante di Tai Chi',
  text: 'L’atlante visivo è lo strumento che uso di più: spiego le transizioni con molta più chiarezza e correggo senza sovraccaricare gli allievi di informazioni.'
}, {
  initials: 'GF',
  name: 'Giulia F.',
  location: 'Firenze',
  product: 'Operatrice olistica',
  text: 'Le schede degli allievi hanno cambiato il mio modo di seguire i percorsi. Ora so da dove siamo partiti e dove stiamo andando, gruppo per gruppo.'
}, {
  initials: 'MP',
  name: 'Marco P.',
  location: 'Padova',
  product: 'Istruttore di Chi Kung',
  text: 'Il calendario stagionale mi ha permesso di passare dalla singola lezione a un programma annuale con una direzione chiara. Gli allievi percepiscono la continuità.'
}];
export const MoreTestimonials = () => <Section className="pb-16" data-id="element-245" data-mp="vuhplkv0p09c">
    <SectionHeading eyebrow="Testimonianze" className="mb-12" data-id="element-246" data-mp="qt0ts3re43zm">
      Cosa dicono gli istruttori che lo usano
    </SectionHeading>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-247" data-mp="32g4aha0akoos">
      {testimonials.map(t => <TestimonialCard key={t.name} {...t} data-id="element-248" data-mp="37efjxjmocx6h" />)}
    </div>
  </Section>;